import { jsxs, jsx } from 'react/jsx-runtime';
import { memo, useEffect } from 'react';
import { scrollIntoView } from '../../tools/scroll.js';
import S from './Heading.styl.js';

let subscribersCount = 0;
function onClick(e) {
    const href = e.target?.getAttribute('href');
    if (!href || !/#/.test(href))
        return;
    const [path, hash] = href.split('#');
    const heading = document.getElementById(hash);
    if (heading) {
        scrollIntoView(heading);
        e.stopPropagation();
    }
}
function subscribe() {
    if (subscribersCount === 0) {
        window.addEventListener('click', onClick, true);
    }
    subscribersCount++;
}
function unsubscribe() {
    if (--subscribersCount === 0) {
        window.removeEventListener('click', onClick, true);
    }
}
const Heading = memo(function Heading({ id, text }) {
    useEffect(() => {
        subscribe();
        return unsubscribe;
    });
    return (jsxs("h2", { className: S.root, id: id, children: [jsx("a", { href: `${location.pathname}#${id}`, className: S.link, children: "#" }), text] }));
});

export { Heading };
